import clsx from 'clsx'
import React, { memo } from 'react'

import { ampli } from '@Analytics/ampli'
import Measure from '@Assets/SVG/Measure'
import { NativeModal, NativeModalBody, NativeModalHeader, useNativeModalActions } from '@Components/Modal/NativeModal/NativeModal'
import { Button } from '@CoreComponents/Buttons/Button'
import { BlockTypeWithGlobal, Maybe } from '@Generated/graphql'
import { useBlockComponents } from '@Globals/CMS/useBlockComponents'
import { useTranslation } from '@Globals/Translations'

import styles from './SizeGuide.module.scss'

export const ProductSizeGuide = memo(({
  blocks,
  children,
  className,
  id,
  showBorderBelow,
  title,
  withIcon,
}: {
  blocks: Maybe<BlockTypeWithGlobal[]>
  children?: React.ReactNode
  className?: string
  id: string
  showBorderBelow?: boolean
  title: string
  withIcon?: boolean
}) => {
  const { t } = useTranslation()
  const actionRef = useNativeModalActions()
  const components = useBlockComponents(blocks || [], id)

  if (!title || components.length === 0) {
    return null
  }

  return (
    <div className={clsx(className, withIcon && styles.sizeGuide, showBorderBelow && styles.showBorderBelow)}>
      <Button fillWidth id={`sizeguide-sidepanel_${id}`} innerSpacing="medium" onClick={() => actionRef.current?.open()} theme="white" type="button">
        <Measure />
        {title}
      </Button>
      <NativeModal actionRef={actionRef} alignment="right" className={styles.modalRight} onOpen={() => ampli.ppGuideInfoLinkOpen()}>
        <NativeModalHeader>
          {t('cms:SIZE_GUIDE_LABEL')}
        </NativeModalHeader>
        <NativeModalBody>
          <div className={styles.accordionContents}>
            {components}
            {children}
          </div>
        </NativeModalBody>
      </NativeModal>
    </div>
  )
})
